/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon[_ngcontent-%COMP%]{margin-bottom:5px!important}.matmenuMaxWidth[_ngcontent-%COMP%]{max-width:none;width:470px;background-color:#adff2f}.limenuitem[_ngcontent-%COMP%]{display:flex;width:100%}.limenuitem[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{width:100%}\n/*# sourceMappingURL=menu.css.map*/"];
export { styles as styles };
